import styled from "styled-components";

export const HappyContainer = styled.div`
  width: 80%;
  display: flex;
  margin: auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
  padding-top: 2rem;
`;

export const HappyCardsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
  @media (width<=768px) {
    flex-direction: column;
  }
`;

export const HappyCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem;
  color: #101e8e;
  background: #fff;
  gap: 0.2rem;
  width: 23%;
  @media (width<=768px) {
    width: 80%;
  }
`;

export const HappyPartners = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  @media (width<=768px) {
    display: grid;
    grid-template-columns: auto auto;
  }
`;

export const HappyParter = styled.div`
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  width: calc((100% / 6) - 0.5rem);
  height: 7rem;

  display: grid;
  place-items: center;
  @media (width<=768px) {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
`;
